export default "__VITE_ASSET__BYn2G4CJ__"